import { useMutation } from "@tanstack/react-query";

import { addOrUpdateFieldEvaluationMetricCorrection } from "services";

import { invalidateQueriesByChunk } from "utils";

import { GET_FIELD_EVALUATION_METRIC_CORRECTIONS, MUTATE_FIELD_EVALUATION_METRIC_CORRECTION } from "consts";

export const useMutateFieldEvaluationMetricCorrection = (fieldId: string) =>
  useMutation({
    mutationKey: [MUTATE_FIELD_EVALUATION_METRIC_CORRECTION],
    mutationFn: addOrUpdateFieldEvaluationMetricCorrection,
    onSuccess: () => {
      invalidateQueriesByChunk(GET_FIELD_EVALUATION_METRIC_CORRECTIONS, fieldId);
    },
  });
